<template>
  <div class="coach-card" id="CoachCard" @click.stop="selectCoach">
    <div v-if="coachData.recommended" class="recommended-lable">Recommended</div>
    <div class="coach-card-left">
      <div class="coach-img-container">
        <img
          v-if="coachData.avatar_url"
          :src="coachData.avatar_url"
          alt="Coach avatar"
          class="coach-img"
        />
        <div>
          <p class="coach-name coach-name-left brand-text mb-2">
            {{ coachData.name }}
          </p>
          <p v-if="coachData.availability" class="availability-left coach-info availability brand-text mb-2"><span class="ball"></span>Available {{coachData.availability}}</p>
        </div>
      </div>
      <div class="coach-info-container">
        <p v-if="coachData.position" class="coach-info brand-text mb-2">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
          {{ coachData.position }}
        </p>
        <p v-if="coachData.started" class="coach-info brand-text mb-2">
          <i class="fa fa-calendar-check" aria-hidden="true"></i>
          Since {{ formatDate(coachData.started) }}
        </p>
        <p v-if="coachData.degree" class="coach-info brand-text mb-0">
          <i class="fa fa-graduation-cap" aria-hidden="true"></i>
          {{ coachData.degree }}
        </p>
      </div>
    </div>
    <div class="coach-card-right">
      <div>
        <p class="coach-name coach-name-right brand-text mb-2">
          {{ coachData.name }}
        </p>
        <p v-if="coachData.availability" class="availability-right coach-info availability brand-text mb-2"><span class="ball"></span>Available {{coachData.availability}}</p>
      </div>
      <p class="coach-description brand-label mb-3">
        {{ isFullDescription ? coachData.description : truncatedDescription }}
      </p>
      <b-spinner v-if="isGetCoachLoading" class="brand-primary"></b-spinner>
      <div
        class="video_wrapper animate__animated animate__fadeIn mb-2"
        v-else-if="selectedCoachData && selectedCoachData.video_url && isFullDescription"
      >
        <video
          class="video-fluid"
          :src="selectedCoachData.video_url"
          title="Coach video"
          controls
        ></video>
      </div>
      <button class="learn-more-btn" :disabled="isGetCoachLoading" @click.stop="toggleFullDescription">{{ isFullDescription ? "Show less" : "Learn more" }}</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";

export default {
  name: "CoachCard",
  props: {
    coachData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      isFullDescription: false,
      isGetCoachLoading: false,
      selectedCoachData: null
    }
  },
  computed: {
    truncatedDescription() {
      if (this.coachData.description) {
        return this.coachData.description.length > 200
          ? this.coachData.description.slice(0, 200) + "..."
          : this.coachData.description;
      } else {
        return "No description provided for this coach";
      }
    }
  },
  methods: {
    async toggleFullDescription() {
      this.isFullDescription = !this.isFullDescription
      if (!this.selectedCoachData) {
        await this.getCoach(this.coachData.id)
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "long" };
      return date.toLocaleString("en-US", options);
    },
    selectCoach() {
      this.$emit("select", this.coachData.id);
    },
    async getCoach(coachId) {
      if (this.isGetCoachLoading) return;
      try {
        this.isGetCoachLoading = true;
        const payload = {
          user_id: this.$store.getters.user_id,
          coach_id: coachId
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/coach/get-coach",
          payload,
          config.options
        );
        if (res.data.success) {
          this.selectedCoachData = res.data.coach;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isGetCoachLoading = false;
      }
    },
  }
};
</script>

<style lang="less">
.coach-card {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  border-radius: 16px;
  box-shadow: 0px 4px 4px 0px #00000040;
  overflow: hidden;
  transition: all 0.1s;

  .coach-card-left,
  .coach-card-right {
    display: flex;
    padding: 20px 16px 16px;
  }

  .coach-card-left {
    flex-direction: column;
    flex: 1 1 40%;
    max-width: 200px;
    background-color: #f0efef;
    padding-top: 32px;
  }

  .coach-card-right {
    flex: 1 1 60%;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .coach-img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .coach-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    align-self: center;
  }

  .coach-name {
    font-family: "PlusJakartaSansBold";
    font-size: 1.6rem;
    line-height: 1.8rem;
    margin-bottom: 8px;
  }

  .coach-name-left, .availability-left {
    display: none;
  }

  .coach-description {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  .coach-info {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  .learn-more-btn {
    min-width: 132px;
    border: 2px solid #0f152e;
    color: #0f152e;
    font-size: 1.4rem;
    font-family: "PlusJakartaSansBold";
    border-radius: 40px;
    padding: 8px 24px;
    background-color: #fff;
    transition: all 0.3s;
    box-shadow: 0px 4px 4px 0px #00000040;

    &:hover {
      background-color: #f6f6f6;
    }
  }

  .recommended-lable {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px 12px;
    background-color: #f1c361;
    color: #fff;
    border-bottom-left-radius: 20px;
    font-size: 1.4rem;
    font-family: "PlusJakartaSansBold";
  }

  .fa {
    width: 14px;
    margin-right: 4px;
  }

  .availability {
    font-family: "PlusJakartaSansBold";
    font-size: 1.4rem;

    .ball {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #0BDA51;
      margin-right: 10px;
    }
  }

  .video-fluid {
    max-width: 400px;
    height: 400px;
    object-fit: contain;
    border-radius: 16px;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
}

@media only screen and (max-width: 480px) {
  .coach-card {
    flex-direction: column;

    .coach-card-left {
      max-width: 100%;
      flex: 1 1 100%;
    }
    .coach-card-right {
      align-items: center;
    }
    .coach-name-right, .availability-right {
      display: none;
    }
    .coach-name-left {
      text-align: center;
      display: block;
      font-size: 2rem;
    }
    .availability-left {
      display: block;
    }
    .coach-description {
      text-align: center;
    }
    .coach-info-container {
      max-width: 300px;
      margin: 0;
    }
    .coach-img-container {
      justify-content: flex-start;
    }
    .recommended-lable {
      align-self: flex-end;
    }
  }
}
</style>
